
import { Component, Vue, Prop } from 'vue-property-decorator';
import { assignClientToPlan } from '@/api/clientPaymentPlan';
import { getPlanById } from '@/api/plans';
import Input from '@/components/form/input.vue';

interface ILicensesUsage {
  app_exhibitor_license_usage: number,
  app_event_manager_license_usage: number,
  app_attendee_license_usage: number,
  app_event_license_usage: number,
}

interface IPlanLimits {
  app_annual_exhibitor_limit: number,
  app_annual_event_manager_limit: number,
  app_annual_attendee_limit: number,
  app_annual_event_limit: number,
}

interface IClientDetails {
  id: number;
  name: object;
  plan_limits: IPlanLimits;
  licenses_usage: ILicensesUsage;
}

@Component({
  name: 'ClientAccountDetail',
  components: { Input }
})
export default class ClientAccountDetail extends Vue {
  @Prop({ type: Object as () => IClientDetails, required: true }) readonly selectedClient!: IClientDetails;

  public form = {
    client_account: {
      label: 'Client Account',
      placeholder: 'Enter client account',
      type: 'number',
      required: true
    },
    payment_plan: {
      label: 'Plan',
      placeholder: 'Enter plan',
      type: 'number',
      required: true
    },
  };

  get graph_limits() {
    if (!this.selectedClient || !this.selectedClient.plan_limits || !this.selectedClient.licenses_usage) {
      return [];
    }
    const { plan_limits, licenses_usage } = this.selectedClient;
    return [
      {
        key: "Events",
        limit: plan_limits.app_annual_event_limit,
        percentage: plan_limits.app_annual_event_limit
          ? (licenses_usage.app_event_license_usage * 100) / plan_limits.app_annual_event_limit
          : 0,
        usage: licenses_usage.app_event_license_usage
      },
      {
        key: "Attendees",
        limit: plan_limits.app_annual_attendee_limit,
        percentage: plan_limits.app_annual_attendee_limit
          ? (licenses_usage.app_attendee_license_usage * 100) / plan_limits.app_annual_attendee_limit
          : 0,
        usage: licenses_usage.app_attendee_license_usage
      },
      {
        key: "Event Managers",
        limit: plan_limits.app_annual_event_manager_limit,
        percentage: plan_limits.app_annual_event_manager_limit
          ? (licenses_usage.app_event_manager_license_usage * 100) / plan_limits.app_annual_event_manager_limit
          : 0,
        usage: licenses_usage.app_event_manager_license_usage
      },
      {
        key: "Exhibitors",
        limit: plan_limits.app_annual_exhibitor_limit,
        percentage: plan_limits.app_annual_exhibitor_limit
          ? (licenses_usage.app_exhibitor_license_usage * 100) / plan_limits.app_annual_exhibitor_limit
          : 0,
        usage: licenses_usage.app_exhibitor_license_usage
      }
    ];
  }

  public available_plans: Array<{ text: string; value: number }> = [];

  public addClientPopup: any = {
    active: false,
    title: '',
    message: '',
    type: '',
    data: null
  };

  async mounted() {
    // No logic here for now
  }

  public discard() {
    this.$router.push('/clients');
  }
}
